module.exports = __webpack_public_path__ + "static/media/239228_06big.ce4dda3e.jpg";